import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Tabs,
  Tab,
  TextField,
  AppBar,
  Toolbar,
} from "@mui/material";

import InventarioSoportes from "../components/InventarioSoportes";
import Sede from "../components/Sede";
import Personal from "../components/Personal";
import Encargados from "../components/Encargados";
import Equipos from "../components/Equipos";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { generatePDF } from "../utils/generatePDF";

const drawerWidth = 240;

const LPD = () => {
  const [formData, setFormData] = useState({});
  const [isOpen, setIsOpen] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [employeeName, setEmployeeName] = useState("");
  const [isNameSet, setIsNameSet] = useState(false);

  const handleFormSubmit = (data, section) => {
    setFormData((prev) => ({
      ...prev,
      [section]: { ...data, nombreEmpleado: employeeName },
    }));
  };

  const toggleSidebar = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSetName = () => {
    if (employeeName.trim() !== "") {
      setIsNameSet(true);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      {/* Sidebar */}
      <Nav isOpen={isOpen} toggleSidebar={toggleSidebar} />

      {/* Contenido Principal */}
      <Box
      className="lpd"
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isOpen ? `${drawerWidth}px` : 0,
          width: isOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
          transition: "margin-left 0.3s ease-in-out, width 0.3s ease-in-out",
        }}
      >
        {" "}
        <AppBar
        className="appbar"
          style={{ marginBottom: "35px", marginLeft: "35px" }}
          position="static"
          sx={{ backgroundColor: "#ededed", color: "#6e6e6e" }}
        >
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              LPD
            </Typography>
          </Toolbar>
        </AppBar>
        <Container maxWidth="md">
          {/* Solicitar Nombre del Empleado antes de continuar */}
          {!isNameSet ? (
            <Box
              sx={{
                backgroundColor: "#fff",
                p: 3,
                borderRadius: 2,
                boxShadow: 2,
                textAlign: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Rellena tu nombre completo para continuar
              </Typography>
              <TextField
                fullWidth
                label="Nombre del Empleado"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
                margin="normal"
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSetName}
                disabled={!employeeName.trim()}
              >
                Continuar
              </Button>
            </Box>
          ) : (
            <>
              {/* Tabs */}
              <Tabs
                value={tabIndex}
                onChange={(e, newIndex) => setTabIndex(newIndex)}
                centered
              >
                <Tab label="Inventario de Soportes" />
                <Tab label="Sede" />
                <Tab label="Personal" />
                <Tab label="Encargados" />
                <Tab label="Equipos" />
              </Tabs>

              {/* Contenido de las Pestañas */}
              <Box
                sx={{
                  backgroundColor: "#fff",
                  p: 3,
                  borderRadius: 2,
                  boxShadow: 2,
                }}
              >
                {tabIndex === 0 && (
                  <>
                    <InventarioSoportes
                      onSubmit={(data) => handleFormSubmit(data, "inventario")}
                    />
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      sx={{ mt: 3 }}
                      disabled={!formData.inventario}
                      onClick={() =>
                        generatePDF(
                          formData.inventario,
                          "Inventario de Soportes"
                        )
                      }
                    >
                      Generar PDF
                    </Button>
                  </>
                )}
                {tabIndex === 1 && (
                  <>
                    <Sede onSubmit={(data) => handleFormSubmit(data, "sede")} />
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      sx={{ mt: 3 }}
                      disabled={!formData.sede}
                      onClick={() => generatePDF(formData.sede, "Sede")}
                    >
                      Generar PDF
                    </Button>
                  </>
                )}
                {tabIndex === 2 && (
                  <>
                    <Personal
                      onSubmit={(data) => handleFormSubmit(data, "personal")}
                    />
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      sx={{ mt: 3 }}
                      disabled={!formData.personal}
                      onClick={() => generatePDF(formData.personal, "Personal")}
                    >
                      Generar PDF
                    </Button>
                  </>
                )}
                {tabIndex === 3 && (
                  <>
                    <Encargados
                      onSubmit={(data) => handleFormSubmit(data, "encargados")}
                    />
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      sx={{ mt: 3 }}
                      disabled={!formData.encargados}
                      onClick={() =>
                        generatePDF(
                          formData.encargados,
                          "Encargados del Tratamiento"
                        )
                      }
                    >
                      Generar PDF
                    </Button>
                  </>
                )}
                {tabIndex === 4 && (
                  <>
                    <Equipos
                      onSubmit={(data) => handleFormSubmit(data, "equipos")}
                    />
                    <Button
                      variant="contained"
                      color="secondary"
                      fullWidth
                      sx={{ mt: 3 }}
                      disabled={!formData.equipos}
                      onClick={() =>
                        generatePDF(formData.equipos, "Equipos Informáticos")
                      }
                    >
                      Generar PDF
                    </Button>
                  </>
                )}
              </Box>
            </>
          )}
        </Container>
      </Box>

      {/* Footer con full width */}
      <Box sx={{ width: "100%", position: "relative", mt: "auto" }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default LPD;
